<template>
  <div
    class="grid h-screen place-items-center fixed inset-0 bg-black/60 z-50"
    @click.self.exact="$event.stopPropagation()"
    @keydown.tab.prevent.exact
    @keydown.shift.tab.prevent.exact
  >
    <div
      class="px-16 py-20 bg-white rounded-lg shadow-2xl w-[400px]"
      @click.stop
    >
      <div class="flex flex-col space-y-7 text-center">
        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-28 h-28 mx-auto text-gray-400"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"
            />
          </svg>
        </div>
        <div class="text-3xl font-bold">
          Verify Your Identity
        </div>
        <div class="text-lg">
          Check your preferred one-time password application for a code.
        </div>
        <div v-if="error" class="text-white text-md font-bold">
          <span class="bg-red-400 p-2 rounded-md">{{ error }}</span>
        </div>
        <div>
          <input
            v-model="code_2fa"
            :disabled="sending"
            type="text"
            inputmode="numeric"
            pattern="[0-9]*"
            maxlength="6"
            autocomplete="one-time-code"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="false"
            placeholder="Enter your one time code"
            class="otp-input p-5 text-2xl w-full text-center bg-white border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
            @keyup.enter="submit"
            @input="onInput"
            @focus="onFocus"
          >
        </div>

        <button
          v-if="!sending"
          type="button"
          :disabled="!code_2fa"
          class="disabled:opacity-20 text-lg items-center text-center justify-center py-5 font-medium text-white bg-primary-500 border border-transparent rounded-md hover:bg-primary-700 focus:outline-none"
          @click="submit"
        >
          Continue
        </button>
        <div
          v-if="!sending"
          class="text-gray-400 hover:text-primary-400 cursor-pointer"
          @click="cancel"
        >
          Cancel
        </div>

        <button
          v-if="sending"
          type="button"
          disabled
          class="inline-flex text-lg items-center text-center justify-center py-5 font-medium text-gray-500 bg-gray-200 border border-transparent rounded-md focus:outline-none"
        >
          Verifying...
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sending: Boolean,
    error: String,
  },
emits: ['submit', 'cancel'],
  data() {
    return {
      code_2fa: "",
    };
  },
  mounted() {
    // Focus cursor on 2fa input when modal mounts
    this.$nextTick(() => {
      const input = this.$el.querySelector('.otp-input');
      if (input) {
        input.focus();
        // Ensure no other inputs are accessible
        this.trapFocus();
      }
    });
  },
  beforeUnmount() {
    // Clean up any focus trapping
    this.removeFocusTrap();
  },
  methods: {
    submit() {
      this.$emit("submit", this.code_2fa);
    },
    cancel() {
      this.$emit("cancel");
    },
    onInput(event) {
      // Clean the input to only allow numbers and limit length
      const value = event.target.value.replace(/\D/g, '').substring(0, 6);
      this.code_2fa = value;

      // Auto-submit option...
      // if (value.length === 6) {
      //   this.$nextTick(() => {
      //     this.submit();
      //   });
      // }
    },
    onFocus() {
      // Ensure this input stays focused and no background elements are accessible
      this.$nextTick(() => {
        const input = this.$el.querySelector('.otp-input');
        if (input && document.activeElement !== input) {
          input.focus();
        }
      });
    },
    trapFocus() {
      // Get all focusable elements within the modal
      const modal = this.$el.querySelector('.bg-white');
      if (!modal) return;

      const focusableElements = modal.querySelectorAll(
        'input, button, [tabindex]:not([tabindex="-1"])'
      );

      if (focusableElements.length === 0) return;

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      // Store original tabindex values
      this.originalTabIndexes = new Map();

      // Disable all elements outside the modal
      document.querySelectorAll('input, button, a, select, textarea, [tabindex]').forEach(el => {
        if (!modal.contains(el)) {
          this.originalTabIndexes.set(el, el.tabIndex);
          el.tabIndex = -1;
        }
      });

      // Handle tab key navigation within modal
      this.handleTabKey = (e) => {
        if (e.key === 'Tab') {
          if (e.shiftKey) {
            if (document.activeElement === firstElement) {
              e.preventDefault();
              lastElement.focus();
            }
          } else {
            if (document.activeElement === lastElement) {
              e.preventDefault();
              firstElement.focus();
            }
          }
        }
      };

      document.addEventListener('keydown', this.handleTabKey);
    },
    removeFocusTrap() {
      // Restore original tabindex values
      if (this.originalTabIndexes) {
        this.originalTabIndexes.forEach((originalTabIndex, el) => {
          if (originalTabIndex === null || originalTabIndex === undefined) {
            el.removeAttribute('tabindex');
          } else {
            el.tabIndex = originalTabIndex;
          }
        });
        this.originalTabIndexes.clear();
      }

      // Remove event listener
      if (this.handleTabKey) {
        document.removeEventListener('keydown', this.handleTabKey);
      }
    },
  },
};
</script>
